//
import mediaRunningReducer from "./mediaRunning/mediaRunning";
import newProductReducer from '../components/allProducts/slices/fetchNewProSlice'
import authSliceReducer from './auth/authSlice'
import blogSliceReducer from '../app/slices/latestBlogSlice'
import { apiSlice } from "./api/apiSlice";
import { apiSliceLatestMachinery } from "./slices/latestMachinerySlice";
import { apiGetMachineSlice } from "./api/createGetMachineApi";
import  authFetchOTPSliceReducer  from "./auth/authFetchOTPSlice";
//
//
const rootReducers = {
  authSliceReducer: authSliceReducer,
  mediaRunning: mediaRunningReducer,
  newProductReducer: newProductReducer,
  blogSliceReducer: blogSliceReducer,
  authFetchOTPSliceReducer: authFetchOTPSliceReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [apiSliceLatestMachinery.reducerPath]: apiSliceLatestMachinery.reducer,
  [apiGetMachineSlice.reducerPath]: apiGetMachineSlice.reducer
};

export default rootReducers;
